export default __webpack_public_path__ + "static/media/icon.aae0f88f.png";